import React, { FC } from 'react'
import { HOSTS } from '../../../../../constants/environment.constants'
import { FIELDS, PARTNERS } from '../../../../../constants/partners'
import ImgUtil from '../../../../../utils/img.utils'
import Typography from '../../../../global/typography'
import {
  GridBox,
  HeaderTags,
  ItemTags,
  PartnerInfo,
  PartnerInfoCountry,
  PartnerLogo,
  PartnerLogoContainer,
} from '../../partnerListings'

type Props = {
  partner: any
  handleTileClick: any
  index: number
}

export const Cards: FC<Props> = ({ partner, handleTileClick, index }) => {
  const partnerDescription = partner[FIELDS.DESCRIPTION] || ''
  const partnerName = partner[FIELDS.NAME] || ''
  const isFeatured = partner[FIELDS.FEATURED] || ''
  const specialization = partner[FIELDS.SPECIALIZATION] || []
  const isAwardWinner = specialization.includes(FIELDS.AWARD_WINNER) || null
  const serviceLevel = partner[FIELDS.SERVICE_LEVEL]
  const certification = partner[FIELDS.CERTIFICATION] || null
  const logo = partner[FIELDS.LOGO] || null
  const country = partner[FIELDS.COUNTRY] || ''
  let partnerLink = partner[FIELDS.WEBSITE] || ''

  //* For non https urls coming from DB
  if (!partnerLink.includes('https:')) partnerLink = partnerLink.replace('http:', 'https:')

  //* Not featured partner that has a Service Name, Service Description, Service Link Href needed for Modal
  const hasModalInfo = !isFeatured && partnerName && partnerDescription && partnerLink
  const isInternalPage = partnerLink && partnerLink.includes(HOSTS.PROD)

  const truncatedDesc =
    partnerDescription.length < 70
      ? partnerDescription
      : partnerDescription.substring(0, 70) + '...'

  const tileInner = (
    <>
      <ItemTags key={index}>
        {isFeatured && (
          <HeaderTags $level="Featured">
            <Typography type="microAlt">Featured</Typography>
          </HeaderTags>
        )}

        <HeaderTags $level={serviceLevel}>
          <Typography type="microAlt">{serviceLevel}</Typography>
        </HeaderTags>

        {certification && (
          <HeaderTags style={{ color: '#FFF', background: '#172125' }}>
            <Typography type="microAlt">Certified</Typography>
          </HeaderTags>
        )}

        {isAwardWinner && (
          <HeaderTags $level="Award">
            <Typography type="microAlt">Award Winner</Typography>
          </HeaderTags>
        )}
      </ItemTags>

      <PartnerLogoContainer>
        <PartnerLogo
          src={logo ? ImgUtil.getResizedImageUrl(logo, '') : PARTNERS.IMG}
          alt={`${partnerName} logo`}
        />
      </PartnerLogoContainer>

      <PartnerInfo>
        <PartnerInfoCountry>{country}</PartnerInfoCountry>
        <h4 className="Partner-Info__Name">{partnerName}</h4>
        <div className="description" dangerouslySetInnerHTML={{ __html: truncatedDesc }}></div>
      </PartnerInfo>
    </>
  )

  if (hasModalInfo) {
    return (
      <GridBox
        key={partner._id}
        onClick={e => handleTileClick(e, partner)}
        rel="noopener noreferrer"
        href="#">
        {tileInner}
      </GridBox>
    )
  } else {
    return (
      <GridBox
        key={partner._id}
        href={partnerLink?.includes('http') ? `${partnerLink}` : `https://${partnerLink}`}
        target={isInternalPage ? '_self' : '_blank'}
        rel="noopener noreferrer nofollow">
        {tileInner}
      </GridBox>
    )
  }
}

export const EmptyResults = () => (
  <div className={`SearchListing__searchNoResults SearchListing__searchNoResults--active`}>
    <h2>No results</h2>
    <p>Your keywords or filter selection produced no results. Maybe you can try to:</p>

    <ul className="SearchListing__searchNoResults__list">
      <li className="SearchListing__searchNoResults__listItem">
        <p>Broaden your search criteria</p>
      </li>

      <li className="SearchListing__searchNoResults__listItem">
        <p>Use different filters</p>
      </li>
    </ul>
  </div>
)
